import { render, staticRenderFns } from "./EditarSignoVital.vue?vue&type=template&id=6a31f1c2&scoped=true"
import script from "./EditarSignoVital.vue?vue&type=script&lang=js"
export * from "./EditarSignoVital.vue?vue&type=script&lang=js"
import style0 from "./EditarSignoVital.vue?vue&type=style&index=0&id=6a31f1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a31f1c2",
  null
  
)

export default component.exports